import patch from './patch';
import { inputValues } from '../selectors/inputs';

export default unitSystem => (dispatch, getState) => {
  const state = getState();
  if (unitSystem === state.ui.unitSystem) return;
  dispatch(patch({
    ui: { unitSystem },
    user_footprint: { inputs: inputValues(state, unitSystem) },
  }));
};
